import CarouselInstanceManager from "./carousel-instance-manager";

(function () {
    // eslint-disable-next-line no-unused-vars
    const carouselInstanceManager = new CarouselInstanceManager();
}());
